import { render, staticRenderFns } from "./EnrollmentData.vue?vue&type=template&id=618d2d71&scoped=true"
import script from "./EnrollmentData.vue?vue&type=script&lang=js"
export * from "./EnrollmentData.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentData.vue?vue&type=style&index=0&id=618d2d71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618d2d71",
  null
  
)

export default component.exports